export default {"src":"/_next/static/media/avatar_w.a686b890.svg","height":50,"width":50};